import type {
  FilesComponentSchema,
  FilesFormatSchemaWithId,
  FilesFormatSchemaWithIdNullable,
} from '@iconik-io/iconik-api/src/services/files';

export function getTrackFromFormat(
  originalFormat: FilesFormatSchemaWithId | FilesFormatSchemaWithIdNullable,
  trackType: FilesComponentSchema['type'],
): Record<string, string | undefined> | undefined {
  return originalFormat.components?.find(
    (component) => component.type.toUpperCase() === trackType.toUpperCase(),
  )?.metadata;
}
